import * as React from 'react';
import classNames from 'classnames';
import { BaseButton } from './base-button';
const IconButton = React.forwardRef((props, forwardedRef) => (React.createElement(BaseButton, { ...props, ref: forwardedRef, className: classNames('rt-IconButton', props.className) })));
IconButton.displayName = 'IconButton';
export { IconButton };
//# sourceMappingURL=icon-button.js.map